import get from 'lodash/get'
import api from '~/api'

let scopesLoadedResolveFn
const loadedPromise = new Promise(resolve => {
  scopesLoadedResolveFn = resolve
})

const state = () => {
  return {
    user: null,
    provider: null,
    scopes: [],
    loadedPromise,
  }
}

const includes = key => ({ scopes }) => scopes.indexOf(key) !== -1

const getters = {
  user: s => s.user,
  provider: s => s.provider,
  meProviderName: s => get(s.provider, 'name', ''),
  meProviderId: s => get(s.provider, 'id', ''),
  scopes: s => s.scopes,
  hasPermission: s => key => s.scopes.indexOf(key) !== -1,
  showCurrentUser: includes('current_user:read'),
  canUpdateCurrentUser: includes('current_user:update'),

  canCreateVerificationEmail: includes('verification-email:create'),
  canCreateWelcomeEmail: includes('welcome-email:create'),

  canCreateApiKey: includes('api_key:create'),
  canDeleteApiKey: includes('api_key:delete'),
  canReadApiKey: includes('api_key:read'),
  canUpdateApiKey: includes('api_key:update'),

  canReadApiLog: includes('api_log:read'),
  canSearchApiLog: includes('api_log:search'),

  showProductsList: includes('product:list_all'),
  showProductDetails: includes('product:read'),
  canSearchProduct: includes('product:search'),
  canCreateProduct: includes('product:create'),
  canUpdateProduct: includes('product:update'),
  canDeleteProduct: includes('product:delete'),

  showProductVersionsList: includes('version:list'),
  showProductVersionDetails: includes('version:read'),
  canSearchProductVersion: includes('version:search'),
  canCreateProductVersion: includes('version:create'),
  canUpdateProductVersion: includes('version:update'),
  canDeleteProductVersion: includes('version:delete'),

  showProvidersList: includes('provider:list'),
  showProviderDetails: includes('provider:read'),
  canSearchProvider: includes('provider:search'),
  canCreateProvider: includes('provider:create'),
  canUpdateProvider: includes('provider:update'),
  canSwitchProvider: includes('provider:switch'),
  canDeleteProvider: includes('provider:delete'),

  showRolesList: includes('role:list_all'),
  showRoleDetails: includes('role:read'),
  canSearchRole: includes('role:search'),
  canCreateRole: includes('role:create'),
  canUpdateRole: includes('role:update'),
  canDeleteRole: includes('role:delete'),

  showUsersList: includes('user:list'),
  showUserDetails: includes('user:read'),
  canSearchUser: includes('user:search'),
  canCreateUser: includes('user:create'),
  canUpdateUser: includes('user:update'),
  canDeleteUser: includes('user:delete'),

  showCategoriesList: includes('category:list'),
  canCreateCategory: includes('category:create'),
  canReadCategory: includes('category:read'),
  canUpdateCategory: includes('category:update'),
  canDeleteCategory: includes('category:delete'),
}

const mutations = {
  SET_ME(state, payload) {
    const payloadCopy = Object.assign({}, payload)

    state.scopes = payloadCopy.scopes
    state.provider = payloadCopy.provider

    delete payloadCopy.scopes
    delete payloadCopy.provider

    state.user = payloadCopy
  },
}

const actions = {
  async GET_ME({ state, commit }) {
    const [error, me] = await api.get('/me')

    if (error) {
      console.error(error)
      return
    }

    commit('SET_ME', me)
    scopesLoadedResolveFn()
  },
  async SET_ME({ commit }, payload) {
    const [error, success] = await api.put('/me', payload)

    if (error) {
      console.error(error)
    }

    return [error, success]
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
